import { render, staticRenderFns } from "./CortaCorrientePantalla.vue?vue&type=template&id=5d58c1ca&scoped=true&"
import script from "./CortaCorrientePantalla.vue?vue&type=script&lang=ts&"
export * from "./CortaCorrientePantalla.vue?vue&type=script&lang=ts&"
import style0 from "./CortaCorrientePantalla.vue?vue&type=style&index=0&id=5d58c1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58c1ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5d58c1ca', component.options)
    } else {
      api.reload('5d58c1ca', component.options)
    }
    module.hot.accept("./CortaCorrientePantalla.vue?vue&type=template&id=5d58c1ca&scoped=true&", function () {
      api.rerender('5d58c1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CortaCorriente/CortaCorrientePantalla.vue"
export default component.exports